$('#dev-related-items-slider').slick({
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 1,
  dots: true,
  responsive: [
      {
        breakpoint: 750, 
        settings: {
          slidesToShow: 3,
        },
      },
    ],
});
